import { combineReducers } from 'redux';
import multiPartyLoadingStateReducerFactory from '@nhl/multi-party-loading-state-reducer-factory';

import actionTypes from './actionTypes';

const loadingStateReducer = multiPartyLoadingStateReducerFactory(actionTypes.REQUEST_USER_LOGIN_STATUS)(actionTypes.USER_LOGIN_STATUS_RESPONSE);

const authenticatedReducer = (state = false, action) => {
    if (action.type === actionTypes.USER_LOGIN_STATUS_RESPONSE) {
        return action.payload.isLoggedIn;
    } else if (action.type === actionTypes.USER_LOGOUT) {
        return false;
    }

    return state;
};

const sessionStateReducer = combineReducers({
    authenticated: authenticatedReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    sessionState: sessionStateReducer
});

export default reducer;